import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class ImpliesExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        if (left) {
            return right;
        }
        else {
            return true;
        }
    }
}
//# sourceMappingURL=ImpliesExpression.js.map